'use client';
import { type ReactNode } from 'react';
import { clsx } from 'clsx';
import { Accordion as UiAccordion } from 'radix-ui';
import { Icon } from 'components/UI/Icon';
import type { PropsWithClassName } from 'types/react-props';
import { generateWeakKey } from 'utils/idGenerator';
import styles from './Accordion.module.scss';

type Item = {
  title: string;
  content: ReactNode;
};

export type AccordionProps = PropsWithClassName<{
  readonly items: ReadonlyArray<Item>;
  readonly type?: 'single' | 'multiple';
}>;

const Accordion = ({ items, type = 'single', className }: AccordionProps) => {
  return (
    <UiAccordion.Root
      className={clsx(styles.root, className)}
      type={type}
      collapsible={type === 'single' ? true : undefined}
    >
      {items.map((item) => {
        const itemKey = generateWeakKey(item, 'accordion-item');
        return (
          <UiAccordion.Item key={itemKey} value={itemKey}>
            <UiAccordion.Trigger className={styles.trigger}>
              <Icon className={styles.icon} name="chevronRight" />
              <h2 className={styles.title}>{item.title}</h2>
            </UiAccordion.Trigger>
            <UiAccordion.Content className={styles.content} forceMount>
              <div className={styles.contentInner}>{item.content}</div>
            </UiAccordion.Content>
          </UiAccordion.Item>
        );
      })}
    </UiAccordion.Root>
  );
};

export default Accordion;
